/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IDobbiesFooterCopyrightsProps } from './dobbies-footer-copyrights.props.autogenerated';

import { IModuleProps, INodeProps } from '@msdyn365-commerce-modules/utilities';
import { RichText, RichTextComponent } from '@msdyn365-commerce/core';
import classnames from 'classnames';

export interface IDobbiesFooterCopyrightsViewProps extends IDobbiesFooterCopyrightsProps<{}> {
    moduleProps: IModuleProps;
    contentProps: INodeProps;
    copyRightsText: React.ReactNode;
}

/**
 *
 * DobbiesFooterCopyrights component
 * @extends {React.PureComponent<IDobbiesFooterCopyrightsProps<{}>>}
 */
class DobbiesFooterCopyrights extends React.PureComponent<IDobbiesFooterCopyrightsProps<{}>> {
    public render(): JSX.Element | null {
        const { copyRights, className } = this.props.config;
        const viewProps = {
            ...this.props,
            moduleProps: { className: classnames('ms-dobbies-footer-copyrights', className), moduleProps: this.props, tag: 'div' },
            contentProps: { className: 'ms-dobbies-footer-copyrights__content', tag: 'div' },
            copyRightsText: this.getCopyRightText(copyRights)
        };
        return this.props.renderView(viewProps) as React.ReactElement;
    }
    /* Following function renders richtext for copy rights */
    private getCopyRightText = (copyRights: RichText | undefined): React.ReactNode => {
        return (
            <div className='copyright-text'>
                {copyRights && (
                    <small>
                        <RichTextComponent text={copyRights} />
                    </small>
                )}
                <a className='dobbies-footor-logo' href='/'>
                    <img
                        className='logo-white'
                        src='https://images-eu-prod.cms.commerce.dynamics.com/cms/api/rsbnfrmlpw/imageFileData/MDk8Hn?pubver=0'
                        alt='Dobbies logo'
                    />
                    <img
                        className='logo-green'
                        src='https://images-eu-prod.cms.commerce.dynamics.com/cms/api/rsbnfrmlpw/imageFileData/MDk8Hq?pubver=1'
                        alt='Dobbies logo'
                    />
                </a>
            </div>
        );
    };
}

export default DobbiesFooterCopyrights;
